import getExchangeRate from "./operations/getExchangeRate.js"

const getData = async (data, operation, prevData = {}) => {
    const { operationType } = operation
    let result = data

    if (operationType === 'getExchangeRate') {
        // Add await to properly wait for the async operation to complete
        result = await getExchangeRate(result, operation, prevData)
    }

    // Return the result if it exists, otherwise return the original data
    if (result) return result
    
    //ALWAYS RETURN AT THE END OF ALL IF STATEMENTS
    return data
}

export default getData
